import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-input',
  template: `
      <ng-content select=".input-group-prepend"></ng-content>
      <input
              [id]="name"
              [type]="type"
              [attr.inputmode]="inputMode"
              [formControl]="$any(control)"
              [placeholder]="placeholder | transloco"
              [min]="min"
              [max]="max"
              [readonly]="readonly"
              [name]="name"
              [autocomplete]="autocomplete"
              [step]="step"
              [pattern]="pattern"
              appInputValidity
              [class]="inputClass"
              (blur)="blurred.emit($event)"
              [style]="inputStyles"
      />
      <ng-content select=".input-group-append"></ng-content>
      <app-input-errors class="input-error" [control]="control"></app-input-errors>
  `,
  styles: ['input { border-radius: 8px; }']
})
export class InputComponent {
  @Input() type = 'text';
  @Input() inputMode = 'text'
  @Input() name = '';
  @Input() control: AbstractControl;
  @Input() min: number;
  @Input() max: number;
  @Input() readonly = false;
  @Input() placeholder = '';
  @Input() inputClass = 'form-control';
  @Input() inputStyles = '';
  @Input() autocomplete: string;
  @Input() step: number;
  @Input() pattern: string;
  @Output() blurred = new EventEmitter<FocusEvent>();
}
